<template>
  <a-layout class="container">
    <a-layout-header>
      <custom-header ref="customHeader"></custom-header>
    </a-layout-header>
    <a-layout-content>
      <router-view @loginShow="loginModelShow"></router-view>
    </a-layout-content>
  </a-layout>
</template>

<script>
import CustomHeader from "../components/globalComponents/Header.vue";
export default {
  name: 'Index',
  components: {
    CustomHeader
  },
  data () {
    return {
      select: 1,
      showBack: false,
      userInfo: {}
    };
  },
  computed: {
  },
  mounted () {
    this.fetchData()
    // window.onresize = () => {
    //   return (() => {
    //     this.initScreenWidth(document.body.clientWidth)
    //   })();
    // };
  },
  methods: {
    fetchData () {

    },
    loginModelShow () {
      this.$refs.customHeader.loginModelShow()
    }
  },
};
</script>

<style scoped lang="scss">
/deep/ .ant-layout-header {
  padding: 0;
  height: 80px !important;
  box-shadow: 0 1px 5px #ccc;
  background-color: #ffffff;
  margin-bottom: 1px;
}

/deep/ .ant-layout-footer {
  padding: 0;
}

.container {
  height: 100%;
  display: flex;
}
</style>